module.exports = __webpack_public_path__ + "img/send_icon_sms.09c0b5d2.svg";